import React, { Component } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import Matrix from './Matrix'
import { isRtl } from '../../../settings'
import { injectIntl, FormattedMessage } from 'react-intl'
import ChoiceTextField from './ChoiceFields/Text'
import ChoiceCheckBox from './ChoiceFields/Checkbox'
import formState from 'components/Pages/FormMaker/formState'
import { observer } from 'mobx-react'
import RawHtml from 'stories/components/RawHtml'

if (isRtl) {
  require('./matrix-input.rtl.css')
} else {
  require('./matrix-input.ltr.css')
}

class AdvanceMatrixInput extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: {} }
  }

  componentDidMount = () => {
    const { choice_groups = [], value: initialValue = {} } = this.props
    this.setState({
      selected: choice_groups
        .map((groups) => groups.slug)
        .reduce((acc, groupSlug) => {
          acc[groupSlug] = initialValue[groupSlug] || ''
          return acc
        }, {}),
    })
  }

  // Object -> void
  onInputChange = (newSelection) => {
    this.setState({ selected: newSelection })
    this.props.onChange(newSelection)
  }

  // String -> void
  onOption = (option) => {
    const [selectedGroup, chosenOption] = option.split(':')
    const { selected: currentSelection } = this.state
    // create the new state
    const newSelection = Object.assign({}, currentSelection, {
      [selectedGroup]: chosenOption,
    })
    this.onInputChange(newSelection)
  }

  // [Object] -> [ReactComponents]
  generateOptionGroup = (group, choices) => {
    const optionGenerator = (__, index) => {
      const choice = choices[index].slug
      const commonProps = {
        key: `matrix-${group.slug}-${choice}`,
      }

      const inputTypes = {
        number: <ChoiceTextField type="number" {...commonProps} />,
        text: <ChoiceTextField type="text" {...commonProps} />,
        boolean: <ChoiceCheckBox {...commonProps} isChecked={() => {}} />,
      }

      const ChoiceInput = inputTypes[choices[index].type]

      return ChoiceInput
    }

    const selectionField = [...Array(choices.length)].map(optionGenerator)

    return (
      <tr
        key={group.slug}
        className="formz-matrix-row formz-advance-matrix-row"
      >
        <td>{group.title}</td>
        {selectionField.map((radioButton, index) => (
          <td key={`option-${index}`}>{radioButton}</td>
        ))}
      </tr>
    )
  }

  // (string, string) -> boolean
  isOptionSelected = (group, option) => this.state.selected[group] === option

  questionColumnTitle = () =>
    formState.$('theme_config').$('customized_texts').$('table_question_label')
      .value || <FormattedMessage id="form.fields.matrix.title" />

  // ([Object]) -> ReactComponents
  generateValuesRow = (choices) => (
    <tr className="formz-matrix-row">
      <th>{this.questionColumnTitle()}</th>

      {choices.map((item, index) => (
        <th key={`choice-${index}`}>{item.title && <p>{item.title}</p>}</th>
      ))}
    </tr>
  )

  // ([choices:Object], [groups:Object]) -> [ReactComponents]
  generateOptions = ({ choices = [], groups = [] }) => {
    const selectRows = groups.map((group) =>
      this.generateOptionGroup(group, choices)
    )
    const valuesRow = this.generateValuesRow(choices)

    return (
      <Matrix
        onChange={this.onOption}
        valuesRow={valuesRow}
        selectRows={selectRows}
      />
    )
  }

  render() {
    const {
      label = '',
      column_groups,
      choice_groups,
      required,
      touched,
      error,
      description,
    } = this.props

    const classNames = {
      'formz-matrix-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <div className="formz-field-and-label-holder">
          <div className="formz-input-title">
            {label} {required && '(*)'}
          </div>

          <RawHtml className="formz-field-description" content={description} />

          {this.generateOptions({
            choices: column_groups,
            groups: choice_groups,
          })}
        </div>
      </FieldRowWrapper>
    )
  }
}

export default injectIntl(observer(AdvanceMatrixInput))
